import { gql } from '@apollo/client';
import { LogType, LogsScreen } from '@components/logsScreen';
import { WorkspacePageHeader } from '@components/page';
import {
  useGetDatasetJobsNameQuery,
  useGetGANDatasetLogQuery,
  useGetGANDatasetNameQuery,
} from '@generated/graphql';
import { useSetPageTitle } from '@seo/SEO';

gql`
  query GetGANDatasetName($workspaceId: String!, $ganDatasetId: String!) {
    getGANDatasets(workspaceId: $workspaceId, datasetId: $ganDatasetId) {
      datasetId
      name
    }
  }
`;

export default ({
  datasetId,
  workspaceId,
  organizationId,
  ganDatasetId,
}: {
  datasetId: string;
  workspaceId: string;
  organizationId: string;
  ganDatasetId: string;
}) => {
  useSetPageTitle('Workspace - dataset logs');

  const { data } = useGetDatasetJobsNameQuery({
    variables: {
      workspaceId,
      datasetId,
    },
  });
  const datasetName = data?.getDatasetJobs?.[0]?.name || '-';

  const { data: ganDatasetMetadata } = useGetGANDatasetNameQuery({
    variables: {
      workspaceId,
      ganDatasetId,
    },
  });
  const ganDatasetName = ganDatasetMetadata?.getGANDatasets?.[0]?.name || '-';

  const { data: ganDatasetLogData, loading: ganDatasetLogLoading } = useGetGANDatasetLogQuery({
    variables: {
      workspaceId,
      datasetId: ganDatasetId,
    },
  });

  const ganDatasetLogsString = ganDatasetLogData?.getGANDatasetLog?.log || '[]';
  const ganDatasetLogs = JSON.parse(`${ganDatasetLogsString}`) as LogType[];
  return (
    <>
      <WorkspacePageHeader
        mainBreadcrumbs={[
          {
            label: 'Datasets',
            href: `/${organizationId}/workspaces/${workspaceId}/datasets/?datasetId=${datasetId}`,
          },
          {
            label: `${datasetName}`,
            href: `/${organizationId}/workspaces/${workspaceId}/datasets/?datasetId=${datasetId}`,
          },
          { label: `${ganDatasetName} logs` },
        ]}
      />
      <LogsScreen logs={ganDatasetLogs} loading={ganDatasetLogLoading} />
    </>
  );
};
